/*
 * tt-size-search.js — size-aware search.
 *
 * "jacket 3y" -> search "jacket" with the Size filter ticked at 3T.
 * "snow boots 10c" -> search "snow boots" with Shoe size 10 ticked.
 * Searches with no size are left alone.
 *
 * parseSizeQuery(q) is pure (no DOM) and is unit-tested in node:
 *   evals/size-search/ in the tootsietootsie-theme repo. Read the README
 *   there before changing a rule, then re-run the evals.
 */
(function () {
  'use strict';

  var P_SIZE = 'filter.v.t.shopify.size';
  var P_SHOE = 'filter.v.t.shopify.shoe-size';

  /* Clothing Size filter values, read from the live /search filter inputs
     on 2026-10-24. m = months interval the value covers, y = ages it covers.
     Membership of the grouped values was sampled from live products:
     0-6m = 3m + 3-6 months, 6-12m = 6-9 + 9-12 months, 1-2y = 12-18 +
     18-24 months, 4T = "4", 5T = "4-5 years", 6-8y = 6/8/"5-6 years",
     9-11y = 10. Age 15 has no value of its own, so it ticks 14 and 16. */
  var CLOTHING = [
    { label: '0-6m', id: 'gid://shopify/FilterSettingGroup/89227287', m: [0, 6] },
    { label: '3m', id: 'gid://shopify/Metaobject/130226323479', m: [0, 3] },
    { label: '3-6 months', id: 'gid://shopify/Metaobject/136050704407', m: [3, 6] },
    { label: '6-12m', id: 'gid://shopify/FilterSettingGroup/89260055', m: [6, 12] },
    { label: '6-9 months', id: 'gid://shopify/Metaobject/130472837143', m: [6, 9] },
    { label: '9-12 months', id: 'gid://shopify/Metaobject/135154499607', m: [9, 12] },
    { label: '1-2y', id: 'gid://shopify/FilterSettingGroup/89292823', m: [12, 24], y: [1] },
    { label: '2T', id: 'gid://shopify/Metaobject/137357557783', y: [2] },
    { label: '3T', id: 'gid://shopify/Metaobject/249536217111', y: [3] },
    { label: '4T', id: 'gid://shopify/FilterSettingGroup/89325591', y: [4] },
    { label: '4', id: 'gid://shopify/Metaobject/140768575511', y: [4] },
    { label: '5T', id: 'gid://shopify/FilterSettingGroup/89358359', y: [5] },
    { label: '6-8y', id: 'gid://shopify/FilterSettingGroup/89391127', y: [6, 7, 8] },
    { label: '9-11y', id: 'gid://shopify/FilterSettingGroup/89423895', y: [9, 10, 11] },
    { label: '12', id: 'gid://shopify/Metaobject/249536774167', y: [12] },
    { label: '12y', id: 'gid://shopify/Metaobject/274378457111', y: [12] },
    { label: '12-13 years', id: 'gid://shopify/Metaobject/274378653719', y: [12, 13] },
    { label: '14', id: 'gid://shopify/Metaobject/249536249879', y: [14, 15] },
    { label: '16', id: 'gid://shopify/Metaobject/249545195543', y: [15, 16] }
  ];

  /* Shoe size filter = Shopify taxonomy "Shoe size" values (bare numbers;
     C and Y share one value, so 4C and 4Y both tick "4"). */
  var SHOE = {
    '0': 17097, '0.5': 2935, '1': 17098, '1.5': 2936, '2': 17099, '2.5': 2937,
    '3': 2938, '3.5': 2939, '4': 17100, '4.5': 2940, '5': 2941, '5.5': 2942,
    '6': 17101, '6.5': 2943, '7': 2944, '7.5': 2945, '8': 17102, '8.5': 2946,
    '9': 2947, '9.5': 2948, '10': 17103, '10.5': 3010, '11': 3011, '11.5': 3012,
    '12': 17210, '12.5': 3013, '13': 3014, '13.5': 3015
  };
  var SHOE_C_MAX = 13.5, SHOE_Y_MIN = 1, SHOE_Y_MAX = 7, CLOTHING_AGE_MAX = 16, T_MAX = 7;

  function set(list) { var o = {}; for (var i = 0; i < list.length; i++) o[list[i]] = 1; return o; }

  /* A query is about footwear when it has one of these words. */
  var FOOT_WORDS = set(('shoes shoe boots boot sneakers sneaker runners trainers sandals sandal ' +
    'slippers slipper booties bootie crocs croc flats cleats slides moccasins moccasin moccs ' +
    'uggs ugg footwear clogs clog loafers loafer wellies rainboots rainboot snowboots snowboot janes flops').split(' '));
  var FOOT_PHRASES = /\bmary\s?janes?\b|\bflip[\s-]?flops?\b/;
  /* ...but not these, which only contain a footwear word. */
  var NOT_FOOT = /\bboot[\s-]?cut\b|\bshoe\s+(bags?|racks?|cabinets?|organi[sz]ers?|storage|box|boxes|trees?|clips?|charms?|laces?)\b|\bboot\s+(socks?|cuffs?|liners?|bags?)\b/g;

  var MONTHS = set('m mo mos mon mons mont monts month months mth mths mnth mnths mois moi montgs minths monyh monyhs mony montj montjs onths'.split(' '));
  var YEARS = set('yr yrs year years yo yos ans anos años yea yesr x'.split(' ')); // x: "6x"
  var NB = set('nb newborn newborns preemie preemies premie prem'.split(' '));
  /* words around a number that mean it is not a size */
  var BLOCK_NEXT = set('pack packs pk pks piece pieces pc pcs pce in minute minutes min mins tog lb lbs oz ml cm mm inch inches ft + % am pm hr hrs hour hours day days st nd rd th dollars off'.split(' '));
  var BLOCK_PREV = set('book books vol volume part level lego duplo puzzle puzzles of $ # no number season series episode chapter gen generation model version page price calendar in'.split(' '));
  /* words that can sit right before/after the number as part of the size */
  var MARKERS = set('size sz siz age us c t toddler youth kids kid infant big little'.split(' '));
  var SUFFIXES = set(Object.keys(MONTHS).concat(Object.keys(YEARS), ['y', 't', 'c', 'us'], Object.keys(BLOCK_NEXT)));
  var FILLER = set('size sz siz age'.split(' ')); // not "old": Old Navy
  /* Month brackets people type without a unit ("3-6 snowsuit"). */
  var MONTH_BRACKETS = set('0-1 0-3 0-6 3-6 3-9 6-9 6-12 9-12 9-18 12-18 12-24 18-24'.split(' '));

  function isNum(t) { return typeof t === 'string' && /^\d{1,2}(\.5|\.0)?$/.test(t); }

  function normalize(q) {
    var s = String(q || '').toLowerCase();
    s = s.replace(/(\d)\s*½/g, '$1.5').replace(/½/g, '.5').replace(/[–—]/g, '-');
    s = s.replace(/(\d)\s+1\/2(?!\d)/g, '$1.5');
    s = s.replace(/(\d)\s*\/\s*(\d)/g, '$1-$2');
    s = s.replace(/(\d)([a-z]{0,6})\s+(?:to|or)\s+(\d)/g, '$1$2-$3'); // "6 to 12", "9 or 10", "6m to 12m"
    s = s.replace(/[!?,;:"'()\[\]{}@*=<>~^|\\]+/g, ' ');
    s = s.replace(/\.(?!\d)/g, ' ').replace(/(^|[^\d])\./g, '$1 ');
    s = s.replace(/(\d)\s*-\s*(?=[\da-z])/g, '$1-');
    return s.replace(/\s+/g, ' ').trim();
  }

  function splitPart(p, out) {
    var m = p.match(/^(us|sz|size|c|t)?(\d{1,2}(?:\.\d)?)([a-z%+]+)?$/);
    if (m && (m[1] || m[3]) && (!m[3] || SUFFIXES[m[3]])) {
      if (m[1]) out.push(m[1]);
      out.push(m[2]);
      if (m[3]) out.push(m[3]);
    } else out.push(p);
  }

  function tokenize(s) {
    var raw = s ? s.split(' ') : [], out = [];
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i];
      if (/\d/.test(t) && /^[a-z0-9.%+]+(-[a-z0-9.%+]*)+$/.test(t)) {
        var parts = t.split('-');
        for (var k = 0; k < parts.length; k++) {
          if (k) out.push('-');
          if (parts[k]) splitPart(parts[k], out);
        }
      } else splitPart(t, out);
    }
    return out;
  }

  function num(t) { return parseFloat(t); }
  function key(n) { return String(Math.round(n * 2) / 2); }

  function hasFootwear(s) {
    var t = s.replace(NOT_FOOT, ' ');
    if (FOOT_PHRASES.test(t)) return true;
    var w = t.split(/[\s-]+/);
    for (var i = 0; i < w.length; i++) if (FOOT_WORDS[w[i]]) return true;
    return false;
  }

  /* Read one size expression starting at number token i. */
  function readExpr(tok, i) {
    var e = { start: i, flags: {}, a: null, b: null, unit: null, nb: false };
    if (NB[tok[i]]) { e.nb = true; e.end = i + 1; return e; }
    // markers before the number: "size", "us", "c", "big kid", ...
    var s = i - 1;
    while (s >= 0 && MARKERS[tok[s]]) {
      var w = tok[s];
      if ((w === 'big' || w === 'little') && tok[s + 1] !== 'kid' && tok[s + 1] !== 'kids') break;
      if (w === 'c' || w === 'little') e.flags.C = 1;
      else if (w === 't') e.flags.T = 1;
      else if (w === 'youth' || w === 'big') e.flags.Y = 1;
      else if (w === 'us') e.flags.SHOE = 1;
      else if (w === 'age') e.flags.AGE = 1;
      s--;
    }
    e.start = s + 1;
    if (s >= 0 && BLOCK_PREV[tok[s]]) e.blocked = 'after "' + tok[s] + '"';
    if (s >= 1 && tok[s] === '-' && BLOCK_PREV[tok[s - 1]]) e.blocked = 'after "' + tok[s - 1] + '"'; // "4-in-1"
    e.a = num(tok[i]);
    var j = i + 1, unitA = null, unitB = null;
    if (unit(tok[j])) { unitA = tok[j]; j++; }
    if (tok[j] === '-' && isNum(tok[j + 1])) {
      e.b = num(tok[j + 1]); j += 2;
    } else if (!unitA && isNum(tok[j]) && num(tok[j]) > e.a && num(tok[j]) - e.a <= 6 && !BLOCK_NEXT[tok[j + 1]]) {
      e.b = num(tok[j]); j++; // "12 18 months", "7 8y", "size 5 6"
    }
    if (e.b !== null && unit(tok[j])) { unitB = tok[j]; j++; }
    e.unit = unitB || unitA;
    if (e.unit && YEARS[e.unit] && tok[j] === 'old') j++;
    // markers after: "4 toddler", "4 big kid"
    while (j < tok.length && /^(toddler|youth|kids|kid|infant|big|little)$/.test(tok[j])) {
      if ((tok[j] === 'big' || tok[j] === 'little') && !/^kids?$/.test(tok[j + 1] || '')) break;
      if (tok[j] === 'youth' || tok[j] === 'big') e.flags.Y = 1;
      else if (tok[j] === 'little') e.flags.C = 1;
      j++;
    }
    if (BLOCK_NEXT[tok[j]] && !e.unit) e.blocked = 'before "' + tok[j] + '"';
    if (tok[j] === '-' && BLOCK_NEXT[tok[j + 1]]) e.blocked = 'before "' + tok[j + 1] + '"';
    e.end = j;
    return e;
  }

  function unit(t) { return !!t && (MONTHS[t] || YEARS[t] || t === 'y' || t === 't' || t === 'c' || t === 'us'); }

  function monthsValues(lo, hi) {
    var out = [];
    for (var i = 0; i < CLOTHING.length; i++) {
      var v = CLOTHING[i];
      if (v.m && lo < v.m[1] && hi > v.m[0]) out.push(v);
    }
    return out;
  }

  function agesValues(a, b) {
    if (a % 1 || b % 1 || a < 1 || b > CLOTHING_AGE_MAX || b < a) return null;
    var out = [];
    for (var i = 0; i < CLOTHING.length; i++) {
      var v = CLOTHING[i];
      if (!v.y) continue;
      for (var k = 0; k < v.y.length; k++) if (v.y[k] >= a && v.y[k] <= b) { out.push(v); break; }
    }
    return out;
  }

  function shoeValues(a, b, min, max) {
    if (b < a || a < min || b > max) return null;
    var out = [];
    for (var n = a; n <= b + 1e-9; n += 0.5) {
      if (!SHOE[key(n)]) return null;
      out.push(key(n));
    }
    return out;
  }

  /* Decide what an expression means. Returns {param, values, label, explicit} or {invalid}. */
  function classify(e, shoe) {
    var a = e.a, b = e.b === null ? e.a : e.b, range = e.b !== null, u = e.unit, f = e.flags;
    var lbl = range ? key(a) + '-' + key(b) : key(a);
    function months() {
      if (a % 1 || b % 1) return null;
      var lo = range ? a : Math.max(0, a - 3), hi = range ? b : Math.max(a, 3);
      if (hi > 24 || lo >= hi) return null;
      return { param: P_SIZE, values: monthsValues(lo, hi), label: lbl + 'M' };
    }
    function ages(sfx) {
      var v = agesValues(a, b);
      return v && v.length ? { param: P_SIZE, values: v, label: lbl + sfx } : null;
    }
    function shoes(min, max, sfx) {
      var v = shoeValues(a, b, min, max);
      return v ? { param: P_SHOE, shoe: v, label: lbl + sfx } : null;
    }
    var r;
    if (e.nb) r = { param: P_SIZE, values: monthsValues(0, 3), label: 'newborn' };
    else if (u && MONTHS[u]) r = months();
    else if (u === 'c' || f.C) r = shoes(0, SHOE_C_MAX, 'C');
    else if (f.Y || (u === 'y' && (shoe || f.SHOE))) r = shoes(SHOE_Y_MIN, SHOE_Y_MAX, 'Y');
    else if (u === 'y' || (u && YEARS[u])) r = ages('Y');
    else if (u === 't' || f.T) {
      // the unit decides: 2T-7T are clothing even next to a shoe word;
      // "10 t shoes" (no clothing 10T) is a toddler shoe size
      if (b <= T_MAX) r = ages('T');
      else if (shoe || f.SHOE) r = shoes(0, SHOE_C_MAX, 'C');
      else r = null;
    }
    else if (u === 'us' || f.SHOE) r = shoes(0, SHOE_C_MAX, '');
    else if (f.AGE) r = ages('Y');
    else if (shoe) {
      if (!range || b - a <= 1) r = shoes(0, SHOE_C_MAX, '');
      else if (MONTH_BRACKETS[lbl]) r = months();
      else r = null;
    } else {
      // half sizes need a shoe word: agesValues rejects them
      if (range && MONTH_BRACKETS[lbl]) r = months();
      else if (range) r = (b - a <= 4) ? ages('') : null;
      else if (a === 18 || a === 24) r = months(); // no kids clothing size 18 or 24: months
      else r = ages('');
    }
    if (!r) return { invalid: true };
    r.explicit = !!(e.nb || u || f.C || f.T || f.Y || f.SHOE || f.AGE);
    return r;
  }

  function parseSizeQuery(q) {
    var original = String(q || '').trim();
    var s = normalize(original);
    var tok = tokenize(s);
    var shoe = hasFootwear(s);
    var consumed = {}, found = [], notes = [];
    for (var i = 0; i < tok.length;) {
      if (!isNum(tok[i]) && !NB[tok[i]]) { i++; continue; }
      var e = readExpr(tok, i);
      if (e.blocked) { notes.push(tok[i] + ' ' + e.blocked); i = Math.max(e.end, i + 1); continue; }
      var c = classify(e, shoe);
      if (c.invalid) { notes.push(tok[i] + ' is not a kids size here'); i = Math.max(e.end, i + 1); continue; }
      for (var k = e.start; k < e.end; k++) consumed[k] = 1;
      found.push(c);
      i = e.end;
    }
    var none = { words: original, filters: [], reason: notes.length ? 'left alone: ' + notes.join('; ') : 'no size' };
    if (!found.length) return none;

    var words = [];
    for (var w = 0; w < tok.length; w++) {
      if (consumed[w] || tok[w] === '-' || FILLER[tok[w]]) continue;
      words.push(tok[w]);
    }
    var explicit = false, onlyNb = true;
    for (var x = 0; x < found.length; x++) {
      if (found[x].explicit) explicit = true;
      if (found[x].label !== 'newborn') onlyNb = false;
    }
    if (!words.length && !explicit) { none.reason = 'left alone: a number with no product word'; return none; }
    if (!words.length && onlyNb) { none.reason = 'left alone: newborn on its own is a word search'; return none; }

    var byParam = {}, order = [], labels = [];
    for (var y = 0; y < found.length; y++) {
      var f = found[y];
      if (!byParam[f.param]) { byParam[f.param] = {}; order.push(f.param); }
      if (f.shoe) for (var z = 0; z < f.shoe.length; z++) byParam[f.param][f.shoe[z]] = 'gid://shopify/TaxonomyValue/' + SHOE[f.shoe[z]];
      else for (var z2 = 0; z2 < f.values.length; z2++) byParam[f.param][f.values[z2].label] = f.values[z2].id;
      labels.push(f.label);
    }
    var filters = [];
    for (var o = 0; o < order.length; o++) {
      var p = order[o], vals = [], labs = [];
      var src = p === P_SHOE ? Object.keys(SHOE).sort(function (m, n) { return num(m) - num(n); }) : CLOTHING.map(function (v) { return v.label; });
      for (var r = 0; r < src.length; r++) if (byParam[p][src[r]]) { vals.push(byParam[p][src[r]]); labs.push(src[r]); }
      filters.push({ param: p, values: vals, labels: labs });
    }
    return {
      words: words.join(' '),
      filters: filters,
      sizeLabel: labels.join(' / '),
      reason: (shoe ? 'footwear ' : '') + labels.join(', ') + ' -> ' + filters.map(function (fl) { return (fl.param === P_SHOE ? 'Shoe size ' : 'Size ') + fl.labels.join('|'); }).join(' + ')
    };
  }

  var api = { parseSizeQuery: parseSizeQuery, normalize: normalize, tokenize: tokenize, P_SIZE: P_SIZE, P_SHOE: P_SHOE, CLOTHING: CLOTHING, SHOE: SHOE };
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.ttSizeSearch = api;

  /* ---------------- storefront glue ---------------- */

  var COUNT_SECTION = 'tt-size-search-count';
  var searchPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'search';

  function filteredUrl(r, base) {
    var p = new URLSearchParams(base || '');
    p.delete('q');
    p.set('q', r.words || '*');
    if (!p.get('type')) p.set('type', 'product');
    r.filters.forEach(function (f) { f.values.forEach(function (v) { p.append(f.param, v); }); });
    p.set('tt_ss', '1');
    return searchPath + '?' + p.toString();
  }

  function fallbackUrl(r, original, base) {
    var p = new URLSearchParams(base || '');
    p.delete('q');
    p.set('q', r.words || original);
    p.set('tt_nosize', r.sizeLabel);
    p.set('tt_w', r.words);
    return searchPath + '?' + p.toString();
  }

  function countResults(url) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 2500);
    return fetch(url + '&section_id=' + COUNT_SECTION, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (res) { return res.text(); })
      .then(function (t) { clearTimeout(timer); var m = t.match(/data-count="(\d+)"/); return m ? parseInt(m[1], 10) : null; })
      .catch(function () { clearTimeout(timer); return null; });
  }

  function go(r, original, base, replace) {
    var url = filteredUrl(r, base);
    var nav = function (u) { if (replace) location.replace(u); else location.assign(u); };
    countResults(url).then(function (n) { nav(n === 0 ? fallbackUrl(r, original, base) : url); });
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    try { return /\/search\/?$/.test(new URL(form.getAttribute('action') || '', location.href).pathname); }
    catch (err) { return false; }
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!isSearchForm(form)) return;
    var input = form.querySelector('[name="q"]');
    if (!input) return;
    var r = parseSizeQuery(input.value);
    if (!r.filters.length) return;
    ev.preventDefault();
    var base = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (k !== 'q' && typeof v === 'string') base.append(k, v); });
    go(r, input.value.trim(), base.toString(), false);
  }, true);

  function onSearchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var params = new URLSearchParams(location.search);
    var q = params.get('q') || '';

    if (params.has('tt_nosize')) { showNote(params.get('tt_w') || '', params.get('tt_nosize')); return; }

    var hasFilter = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });

    // Landed on our filtered URL and it came back empty (results changed since the check).
    if (params.has('tt_ss')) {
      if (hasFilter && !params.get('page') && !document.querySelector('#product-grid .grid__item, #product-grid li')) {
        var r0 = { words: q === '*' ? '' : q, sizeLabel: '' };
        var labels = document.querySelectorAll('.active-facets__button-inner');
        r0.sizeLabel = labels.length ? (labels[0].textContent || '').replace(/^[^:]*:\s*/, '').replace(/\s+/g, ' ').trim() : 'that size';
        location.replace(fallbackUrl(r0, q, ''));
      }
      return;
    }

    // Pasted or linked URL like /search?q=jacket+3y: rewrite once.
    if (!q || hasFilter) return;
    var r = parseSizeQuery(q);
    if (!r.filters.length) return;
    params.delete('q');
    go(r, q, params.toString(), true);
  }

  function showNote(words, size) {
    if (document.querySelector('.tt-size-note')) return;
    var p = document.createElement('p');
    p.className = 'tt-size-note';
    p.setAttribute('role', 'status');
    var b = document.createElement('strong');
    b.textContent = size;
    p.appendChild(document.createTextNode(words ? 'No ' + words + ' in size ' : 'Nothing in size '));
    p.appendChild(b);
    p.appendChild(document.createTextNode(' right now. Showing all sizes.'));
    var anchor = document.querySelector('.template-search__search');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(p, anchor.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onSearchPage);
  else onSearchPage();
})();
